import { Reducer } from '@reduxjs/toolkit'
import { CommentsAction } from './comments.actions'
import {
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_FAILURE,
  GET_COMMENTS_REQUESTED,
  ADD_COMMENT_SUCCESS,
  UPDATE_COMMENT_SUCCESS,
} from './comments.constants'

interface CommentsState {
  loading: boolean,
  error: boolean,
  data: $TSFIXME[],
}

const initialState: CommentsState = {
  loading: true,
  error: false,
  data: [],
}

const reducer: Reducer<CommentsState, CommentsAction> = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMENTS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
        data: [],
      }
    case GET_COMMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.data,
      }

    case GET_COMMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      }

    case ADD_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: [...state.data, action.data],
      }

    case UPDATE_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: state.data.map(comment => {
          if (comment['$ref'] === action.data['$ref']) {
            return action.data
          }
          return comment
        }),
      }

    default:
      return state
  }
}

export default reducer
